import { Icon } from '@hologram-dimension/icon';
import clsx from 'clsx/lite';
import { type FC } from 'react';
import styles from './Pictogram.module.css';

type IconParams = GetReactParameterBag<typeof Icon>;
type IconFill = IconParams['fill'];
type IconName = IconParams['name'];

interface PictogramProps extends IconParams {
  name: IconName;
  color?: IconFill;
  iconClassName?: string;
  className?: string;
}

const Pictogram: FC<PictogramProps> = (props) => {
  const { name, color, iconClassName, className, ...rest } = props;

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Icon
        name={name}
        size="large"
        fill={color}
        className={clsx(styles.icon, iconClassName)}
        {...rest}
      />
    </div>
  );
};

export default Pictogram;
